import { z } from 'zod';
// Tipo base de notificación. Cada feature agrega los suyos según necesite
// (debe mantenerse en sync con el enum TipoNotificacion de Prisma).
export const TIPOS_NOTIFICACION = ['SISTEMA', 'PUBLICACION', 'CONEXION', 'CAMPANA'];
export const notificacionPublicSchema = z.object({
    id: z.string(),
    tipo: z.enum(TIPOS_NOTIFICACION),
    contextoTipo: z.string(),
    contextoId: z.string(),
    titulo: z.string(),
    cuerpo: z.string(),
    leidoEn: z.string().nullable(),
    creadoEn: z.string(),
});
export const notificacionListarQuerySchema = z.object({
    soloNoLeidas: z
        .union([z.literal('true'), z.literal('false'), z.boolean()])
        .transform((v) => v === true || v === 'true')
        .optional(),
    limit: z.coerce.number().int().min(1).max(100).default(20),
});
//# sourceMappingURL=notificacion.js.map